<template>
  <div v-if="reservation">
    <v-btn
      :to="'/events/' + $route.params.id"
      class="ma-0 mb-5"
      transparent
    >
      Назад
    </v-btn>
    <v-btn
      :to="'/events/' + $route.params.id + '/' + $route.params.reservation_id + '/edit'"
      class="ma-0 mb-5"
      transparent
      color="success ml-5"
    >
      Редактировать
    </v-btn>
    <v-btn
      v-if="reservation.booking_status !== 'cancelled'"
      class="ma-0 mb-5"
      transparent
      color="warning ml-5"
      @click="cancel_dialog = true"
    >
      Отменить
    </v-btn>
    <v-btn
      class="ma-0 mb-5"
      transparent
      color="error ml-5"
      @click="confirmDelete(front_reservation.uuid)"
    >
      Удалить
    </v-btn>

    <!-- Баннер отменённой брони -->
    <v-alert
      v-if="reservation.booking_status === 'cancelled'"
      type="warning"
      class="mb-4"
      dense
    >
      Бронирование отменено
      <span v-if="reservation.cancelled_at"> · {{ reservation.cancelled_at }}</span>
      <span v-if="reservation.cancel_reason"> · {{ reservation.cancel_reason }}</span>
    </v-alert>

    <p class="text-2xl mb-6">
      <span v-if="reservation.order_id">Бронирование №{{ reservation.order_id }}</span>
      <span v-else class="grey--text">Бронирование (номер снят)</span>
      <v-btn
        v-if="!reservation.confirm && reservation.booking_status !== 'cancelled'"
        small
        transparent
        @click="confirmReservation(front_reservation.reservation_uuid)"
      >
        Подвердить оказание услуги
      </v-btn>
      <v-chip
        v-else-if="reservation.confirm"
        class="ma-2"
        small
        color="success"
      >
        Услуга оказана
      </v-chip>
    </p>
    <v-row>
      <v-col
        cols="12"
        class="mb-12"
        xs="12"
        sm="12"
        md="12"
        lg="7"
      >
        <v-card class="overflow-hidden mb-5">
          <v-card-title
            class="mt-3"
            style="font-size: 20px; font-weigth: bold"
          >
            Контакты клиента
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text>
            <ul class="client_data">
              <li>Имя: {{ reservation.client.name }}</li>
              <li>Email: {{ reservation.client.email }}</li>
              <li>Телефон: {{ reservation.client.phone }}</li>
              <li>Бонусные баллы: {{ reservation.client.bonuspoint }}</li>
            </ul>
          </v-card-text>
        </v-card>
        <v-card class="overflow-hidden">
          <v-row class="ma-0 h-full">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card-title
                class="mt-2"
                style="font-size: 25px; font-weigth: bold"
              >
                {{ reservation.header }}
              </v-card-title>
              <v-card-text>
                <v-divider></v-divider>
              </v-card-text>
              <div
                v-for="room in reservation.suits"
                :key="room.id"
              >
                <v-card-text class="d-flex">
                  <div v-show="room.image">
                    <v-avatar
                      rounded
                      size="120"
                    >
                      <v-img :src="'https://lk.xbadm.ru' + room.image"></v-img>
                    </v-avatar>
                  </div>
                  <div>
                    <v-card-title style="font-size: 16px">
                      {{ room.name }} №{{ room.room_number }}
                    </v-card-title>
                    <v-card-subtitle class="text-xs pb-0">
                      {{ room.options.package }} <br />
                      {{ room.available_room_type[0] }}
                    </v-card-subtitle>
                  </div>
                </v-card-text>
                <v-card-text>
                  <v-divider></v-divider>
                </v-card-text>
                <div
                  v-for="participant in room.participants"
                  :key="participant.id"
                >
                  <div>
                    <v-card-text>
                      <h2 class="font-weight-medium">
                        {{ participant.name }}
                      </h2>
                      <div>Даты пребывания: {{ participant.start }} - {{ participant.end }}</div>
                      <span class="text-xs text-no-wrap">{{ participant.age }}</span>
                      <span
                        v-if="participant.childAge"
                        class="text-xs text-no-wrap"
                      >, {{ participant.childAge }}
                        лет</span>
                      <span class="text-xs text-no-wrap">, {{ participant.participantType }}</span>
                    </v-card-text>
                  </div>
                  <v-card-text>
                    <div class="d-flex justify-space-between">
                      <div v-if="participant.price.base_price == participant.price.price">
                        Цена
                      </div>
                      <div v-else>
                        Базовая стоимость
                      </div>
                      <div class="font-weight-semibold">
                        {{ participant.price.base_price | format }} ₽
                      </div>
                    </div>

                    <div
                      v-if="participant.price.discount.discount > 0"
                      class="d-flex justify-space-between"
                    >
                      <div v-if="participant.price.discount">
                        {{ participant.price.discount.name }}
                      </div>
                      <div v-else>
                        Скидка
                      </div>
                      <div class="font-weight-semibold success--text">
                        - {{ participant.price.discount.discount | format }} ₽
                      </div>
                    </div>
                    <div
                      v-if="participant.price.overprice.overprice > 0"
                      class="d-flex justify-space-between"
                    >
                      <div>{{ participant.price.overprice.name }}</div>
                      <div class="font-weight-semibold warning--text">
                        + {{ participant.price.overprice.overprice | format }} ₽
                      </div>
                    </div>
                    <div
                      v-if="participant.insurance"
                      class="d-flex justify-space-between"
                    >
                      <div>Страховка</div>
                      <div class="font-weight-semibold warning--text">
                        + {{ participant.price.insurance | format }} ₽
                      </div>
                    </div>
                    <div
                      v-if="participant.price.base_price != participant.price.price"
                      class="d-flex justify-space-between"
                    >
                      <div>Цена</div>
                      <div class="font-weight-semibold">
                        {{ participant.price.price | format }} ₽
                      </div>
                    </div>

                    <v-divider class="mt-5"></v-divider>
                  </v-card-text>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <ul class="list_small_data mt-3">
          <li>Дата создания: {{ reservation.date }}</li>
          <li>Последнее обновление: {{ reservation.edit }}</li>
        </ul>
      </v-col>
      <v-col
        cols="12"
        class="mb-12"
        xs="12"
        sm="12"
        md="12"
        lg="5"
      >
        <v-card class="overflow-hidden">
          <v-row class="ma-0 h-full">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card-title class="pt-4">Стоимость бронирования</v-card-title>
              <v-card-text class="pricing-summary pt-0">
                <!-- Проживание -->
                <template v-if="hasRooms">
                  <div class="pricing-section-title">Проживание</div>
                  <div
                    v-for="room in reservation.suits"
                    :key="'summary-room-' + room.id"
                    class="pricing-room-block"
                  >
                    <div class="pricing-row">
                      <span class="pricing-label">
                        {{ room.name }} №{{ room.room_number }}
                        <span v-if="roomStayMeta(room)" class="pricing-meta">{{ roomStayMeta(room) }}</span>
                      </span>
                      <span class="pricing-value">{{ room.price | format }} ₽</span>
                    </div>
                  </div>
                  <div
                    v-if="reservation.suits.length > 1 || servicesTotal > 0"
                    class="pricing-row pricing-row--subtotal"
                  >
                    <span class="pricing-label">Итого за проживание</span>
                    <span class="pricing-value">{{ roomsTotal | format }} ₽</span>
                  </div>
                </template>

                <!-- Дополнительные услуги -->
                <template v-if="servicesTotal > 0">
                  <v-divider class="my-3" />
                <div class="pricing-section-title">Услуги</div>
                  <div
                    v-for="svc in reservation.services"
                    :key="'summary-svc-' + svc.id"
                    class="pricing-row"
                  >
                    <span class="pricing-label">
                      {{ svc.name }}
                      <span class="pricing-meta">{{ svc.unit_price | format }} ₽ × {{ svc.quantity }}</span>
                    </span>
                    <span class="pricing-value">{{ svc.total_price | format }} ₽</span>
                  </div>
                  <div
                    v-if="reservation.services.length > 1"
                    class="pricing-row pricing-row--subtotal"
                  >
                    <span class="pricing-label">Итого за услуги</span>
                    <span class="pricing-value">{{ servicesTotal | format }} ₽</span>
                  </div>
                </template>

                <v-divider class="my-3" />
                <div class="pricing-row pricing-row--subtotal">
                  <span class="pricing-label">Итого по тарифу</span>
                  <span class="pricing-value">{{ tariffTotal | format }} ₽</span>
                </div>

                <!-- Скидки и корректировки -->
                <template v-if="hasAdjustments">
                  <v-divider class="my-3" />
                  <div class="pricing-section-title">Скидки и корректировки</div>

                  <div
                    v-if="promoDiscount > 0"
                    class="pricing-row pricing-row--discount"
                  >
                    <span class="pricing-label">{{ promoDiscountLabel }}</span>
                    <span class="pricing-value">−{{ promoDiscount | format }} ₽</span>
                  </div>

                  <div
                    v-for="(line, idx) in percentDiscountLines"
                    :key="'disc-' + idx"
                    class="pricing-row pricing-row--discount"
                  >
                    <span class="pricing-label">{{ line.text }}</span>
                    <span class="pricing-value">−{{ line.amount | format }} ₽</span>
                  </div>

                  <div
                    v-if="manualAdjustment > 0"
                    class="pricing-row pricing-row--discount"
                  >
                    <span class="pricing-label">{{ manualAdjustmentLabel }}</span>
                    <span class="pricing-value">−{{ manualAdjustment | format }} ₽</span>
                  </div>
                </template>

                <v-divider class="my-3" />
                <div class="pricing-row pricing-row--total">
                  <span class="pricing-label">К оплате</span>
                  <span class="pricing-value pricing-value--total">{{ reservation.pay_price | format }} ₽</span>
                </div>

                <div class="pricing-payment-status mt-4">
                  <div v-if="reservation.pay_price" class="success--text font-weight-semibold">
                    Оплачено: {{ reservation.pay_sum | format }} ₽
                  </div>
                  <div v-else class="font-weight-semibold">
                    Оплачено: 0 ₽
                  </div>
                  <div
                    v-if="reservation.pay_sum > reservation.pay_price"
                    class="error--text font-weight-semibold"
                  >
                    Переплата: {{ reservation.pay_sum - reservation.pay_price | format }} ₽
                  </div>
                </div>
              </v-card-text>
              <v-card-text>
                <v-divider></v-divider>
              </v-card-text>

              <v-card-title>Счета</v-card-title>
                <div
                  v-for="invoice in reservation.invoices"
                  :key="invoice.id"
                  class="summary_block"
                >
                  <div style="position: relative">
                    <v-card-title style="font-size: 15px">
                      Счет №{{ invoice.id }}
                      <v-chip
                        v-if="invoice.warning"
                        class="ml-2"
                        small
                        color="warning"
                      >
                        ⚠️ Требует внимания
                      </v-chip>
                    </v-card-title>
                    <v-card-subtitle class="text-xs pb-0">
                      UUID: {{ invoice.uuid }}
                    </v-card-subtitle>

                    <v-card-text>
                      <v-divider class="mb-3"></v-divider>

                      <div class="invoice-info mb-3">
                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Наименование услуги:</span>
                          <span class="text-right">{{ invoice.name }}</span>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Сумма счета:</span>
                          <span class="font-weight-semibold">{{ invoice.price | format }} ₽</span>
                        </div>

                        <div
                          v-if="invoice.payment_data && invoice.payment_data.amount"
                          class="d-flex justify-space-between mb-2"
                        >
                          <span class="font-weight-medium">Сумма к оплате:</span>
                          <span class="font-weight-semibold">{{ invoice.payment_data.amount | format }} ₽</span>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Номер заказа:</span>
                          <span>{{ invoice.payment_data ? invoice.payment_data.order : '—' }}</span>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Тип счета:</span>
                          <v-chip
                            v-if="invoice.payment_type == 1"
                            small
                            color="primary"
                          >
                            Входящий
                          </v-chip>
                          <v-chip
                            v-else
                            small
                            color="secondary"
                          >
                            Исходящий
                          </v-chip>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Способ оплаты:</span>
                          <v-chip
                            small
                            color="info"
                          >
                            {{ invoice.payment_method_display || payment_method_type[invoice.payment_method] }}
                          </v-chip>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Касса:</span>
                          <span>{{ invoice.cashbox == 1 ? 'Безналичная' : 'Наличная' }}</span>
                        </div>

                        <div
                          v-if="invoice.cashbox == 2"
                          class="mb-2"
                        >
                          <div class="d-flex justify-space-between mb-2 align-center">
                            <span class="font-weight-medium">Тег кассы:</span>
                            <span v-if="editTagInvoiceId !== invoice.id">{{ invoice.cash_register_tag || '—' }}</span>
                            <v-btn
                              v-if="editTagInvoiceId !== invoice.id"
                              x-small
                              text
                              color="primary"
                              @click="startEditTag(invoice)"
                            >
                              {{ invoice.cash_register_tag ? 'Изменить' : 'Добавить' }}
                            </v-btn>
                          </div>
                          <div
                            v-if="editTagInvoiceId === invoice.id"
                            class="d-flex flex-wrap align-center"
                          >
                            <v-text-field
                              v-model="editTagValue"
                              outlined
                              dense
                              hide-details
                              label="Тег кассы"
                              class="mr-2"
                              style="max-width: 200px; flex: 1; min-width: 120px;"
                            ></v-text-field>
                            <v-btn
                              x-small
                              color="success"
                              class="mr-1 mb-1"
                              @click="saveInvoiceTag(invoice.id)"
                            >
                              Сохранить
                            </v-btn>
                            <v-btn
                              x-small
                              color="secondary"
                              class="mr-1 mb-1"
                              @click="clearInvoiceTag(invoice.id)"
                            >
                              Очистить тег
                            </v-btn>
                            <v-btn
                              x-small
                              text
                              class="mb-1"
                              @click="cancelEditTag"
                            >
                              Отмена
                            </v-btn>
                          </div>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Предоплата:</span>
                          <v-chip
                            small
                            :color="invoice.prepay ? 'warning' : 'default'"
                          >
                            {{ invoice.prepay ? 'Да' : 'Нет' }}
                          </v-chip>
                        </div>

                        <div class="d-flex justify-space-between mb-2">
                          <span class="font-weight-medium">Оплачен:</span>
                          <v-chip
                            small
                            :color="invoice.pay ? 'success' : 'error'"
                          >
                            {{ invoice.pay ? 'Да' : 'Нет' }}
                          </v-chip>
                        </div>

                        <div
                          v-if="invoice.comment"
                          class="mt-3 mb-2"
                        >
                          <div class="font-weight-medium mb-1">
                            Комментарий:
                          </div>
                          <div
                            class="text-xs"
                            style="background: #f5f5f5; padding: 8px; border-radius: 4px;"
                          >
                            {{ invoice.comment }}
                          </div>
                        </div>

                        <div
                          v-if="showOfdReceiptBlock(invoice)"
                          class="mt-3 mb-2"
                        >
                          <v-divider class="mb-2"></v-divider>
                          <div class="font-weight-medium mb-2">
                            Фискальный чек (1-ОФД):
                          </div>

                          <div class="d-flex justify-space-between mb-2">
                            <span class="font-weight-medium">Статус:</span>
                            <v-chip
                              small
                              :color="ofdReceiptStatusColor(invoice.ofd_receipt_status)"
                            >
                              {{ ofdReceiptStatusLabel(invoice.ofd_receipt_status) }}
                            </v-chip>
                          </div>

                          <div
                            v-if="invoice.ofd_receipt_id"
                            class="d-flex justify-space-between mb-2"
                          >
                            <span class="font-weight-medium">ID в ОФД:</span>
                            <span class="text-right text-xs">{{ invoice.ofd_receipt_id }}</span>
                          </div>

                          <div
                            v-if="invoice.ofd_fiscal_document_number"
                            class="d-flex justify-space-between mb-2"
                          >
                            <span class="font-weight-medium">ФД:</span>
                            <span>{{ invoice.ofd_fiscal_document_number }}</span>
                          </div>

                          <div
                            v-if="invoice.ofd_fiscal_storage_number"
                            class="d-flex justify-space-between mb-2"
                          >
                            <span class="font-weight-medium">ФН:</span>
                            <span>{{ invoice.ofd_fiscal_storage_number }}</span>
                          </div>

                          <div
                            v-if="invoice.ofd_fiscal_sign"
                            class="d-flex justify-space-between mb-2"
                          >
                            <span class="font-weight-medium">ФП:</span>
                            <span>{{ invoice.ofd_fiscal_sign }}</span>
                          </div>

                          <div
                            v-if="invoice.ofd_receipt_dt"
                            class="d-flex justify-space-between mb-2"
                          >
                            <span class="font-weight-medium">Дата фискализации:</span>
                            <span>{{ formatReceiptDt(invoice.ofd_receipt_dt) }}</span>
                          </div>

                          <a
                            v-if="invoice.ofd_receipt_url"
                            :href="invoice.ofd_receipt_url"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="d-inline-block mb-2"
                          >
                            Открыть чек
                          </a>

                          <v-alert
                            v-if="invoice.ofd_receipt_status === 'done' && !hasReceiptProof(invoice)"
                            type="info"
                            dense
                            outlined
                            class="mt-1 mb-2"
                          >
                            Чек выбит, реквизиты ещё не получены.
                          </v-alert>
                        </div>

                        <div
                          v-if="invoice.payment_data"
                          class="mt-3"
                        >
                          <v-divider class="mb-2"></v-divider>
                          <div class="font-weight-medium mb-2">
                            Данные для оплаты:
                          </div>

                          <div
                            v-if="invoice.payment_data.description"
                            class="mb-2"
                          >
                            <span class="text-xs font-weight-medium">Описание:</span>
                            <div class="text-xs">
                              {{ invoice.payment_data.description }}
                            </div>
                          </div>

                          <div
                            v-if="invoice.payment_data.name"
                            class="mb-2"
                          >
                            <span class="text-xs font-weight-medium">Имя плательщика:</span>
                            <div class="text-xs">
                              {{ invoice.payment_data.name }}
                            </div>
                          </div>

                          <div
                            v-if="invoice.payment_data.email"
                            class="mb-2"
                          >
                            <span class="text-xs font-weight-medium">Email:</span>
                            <div class="text-xs">
                              {{ invoice.payment_data.email }}
                            </div>
                          </div>

                          <div
                            v-if="invoice.payment_data.phone"
                            class="mb-2"
                          >
                            <span class="text-xs font-weight-medium">Телефон:</span>
                            <div class="text-xs">
                              {{ invoice.payment_data.phone }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <v-divider class="mt-3 mb-3"></v-divider>
                    </v-card-text>

                    <v-card-text class="pt-0">
                      <v-btn
                        v-show="!invoice.pay || invoice.cashbox == 2"
                        color="error mb-2"
                        small
                        block
                        @click="deleteInvoice(invoice.id)"
                      >
                        Удалить
                      </v-btn>
                      <v-btn
                        v-show="invoice.payment_method == 1"
                        color="success mb-2"
                        small
                        block
                        @click="checkPay(invoice.id)"
                      >
                        Проверить оплату
                      </v-btn>
                      <v-btn
                        v-show="invoice.payment_method == 2"
                        :color="invoice.pay ? 'error' : 'success'"
                        small
                        block
                        class="mb-2"
                        @click="updateInvoicePayStatus(invoice.id, !invoice.pay)"
                      >
                        {{ invoice.pay ? 'Снять оплату' : 'Отметить оплаченным' }}
                      </v-btn>
                      <v-btn
                        v-show="canRefreshInvoiceReceipt(invoice)"
                        color="primary"
                        small
                        block
                        class="mb-2"
                        :loading="refreshingReceiptId === invoice.id"
                        @click="refreshInvoiceReceipt(invoice.id)"
                      >
                        Обновить статус чека
                      </v-btn>
                    </v-card-text>
                  </div>
                </div>
            </v-col>
          </v-row>
        </v-card>
        <v-btn
          class="ma-0 mb-5 mt-5"
          transparent
          color="success ml-5"
          @click="invoice_modal = true"
        >
          Создать счёт
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog
      v-model="invoice_modal"
      width="700"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Создать новый счет
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-title class="pb-0 mb-0 mt-0 pt-0">
          Тип счета
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="invoice_data.payment_type">
            <v-radio
              :key="1"
              label="Входящий"
              :value="1"
            ></v-radio>
            <v-radio
              :key="2"
              label="Исходящий"
              :value="2"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-text>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-title class="pb-0 mb-0 mt-0 pt-0">
          Выберете кассу
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="invoice_data.cashbox">
            <v-radio
              :key="2"
              label="Наличная касса"
              :value="2"
            ></v-radio>
            <v-radio
              :key="1"
              label="Безналичная касса"
              :value="1"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-text>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-model="invoice_data.name"
            outlined
            hide-details
            label="Наименование услуги"
            required
          >
          </v-text-field>
        </v-card-text>
        <v-card-text>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-model.number="invoice_data.price"
            outlined
            hide-details
            type="number"
            label="Сумма счета"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-model.number="invoice_data.comment"
            outlined
            hide-details
            type="text"
            label="Комментарий"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-text v-show="invoice_data.cashbox == 2">
          <v-text-field
            v-model="invoice_data.cash_register_tag"
            outlined
            hide-details
            label="Тег кассы"
            placeholder="Тег кассы (только для наличных)"
          ></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-checkbox
            v-show="invoice_data.cashbox == 2"
            v-model="invoice_data.status"
            label="Оплачен"
            color="success"
          >
          </v-checkbox>
          <v-checkbox
            v-model="invoice_data.warning"
            label="Обратить внимание на счет"
            color="success"
          ></v-checkbox>
        </v-card-text>
        <v-card-text> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="createCashInvoice"
          >
            Создать
          </v-btn>
          <v-btn
            color=""
            @click="invoice_modal = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="delete_reservation_dialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Подтвердите удаление бронирования
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="delete_confirm"
            label="Для удаления напишите УДАЛИТЬ"
            required
          ></v-text-field>
          <span
            v-show="delete_error"
            style="color: red"
          >{{ delete_error }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="; (delete_reservation_dialog = false), (delete_uuid = null)">
            Отменить
          </v-btn>
          <v-btn
            color="error darken-1"
            @click=" deleteResesrvation(delete_uuid)"
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог мягкой отмены -->
    <v-dialog v-model="cancel_dialog" max-width="460">
      <v-card>
        <v-card-title>Отменить бронирование?</v-card-title>
        <v-card-text>
          Бронирование будет отмечено как отменённое. Номер заказа будет скрыт,
          но запись, счета и суммы сохранятся. Номера будут освобождены.
          <br /><br />
          <v-text-field
            v-model="cancel_reason"
            outlined
            dense
            label="Причина отмены (необязательно)"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancel_dialog = false">Закрыть</v-btn>
          <v-btn color="warning" :loading="cancel_loading" @click="doCancel">Отменить бронирование</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/api'
import {
  finalPayPrice as finalPay,
  hasPricingAdjustments,
  manualAdjustmentAmount,
  percentDiscountLines as buildPercentDiscountLines,
  promoDiscountAmount,
  promoDiscountLabel,
  roomsTotalFromReservation,
  servicesTotalFromReservation,
  tariffTotalFromReservation,
} from '@/utils/reservationPricing'

export default {
  components: {},
  filters: {
    format: val => `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 '),
  },
  data() {
    return {
      invoice_data: {
        payment_type: 1,
        name: 'Оказание комплекса услуг по физической культуре и спорту',
        cashbox: 2,
        price: null,
        status: 0,
        payment_method: 1,
        cash_register_tag: '',
      },
      reservation: null,
      front_reservation: null,
      invoice_modal: false,
      delete_reservation_dialog: false,
      delete_confirm: null,
      delete_error: null,
      delete_uuid: null,
      editTagInvoiceId: null,
      editTagValue: '',
      cancel_dialog: false,
      cancel_loading: false,
      cancel_reason: '',
      refreshingReceiptId: null,
      payment_method_type: {
        1: 'Картой',
        2: 'Наличными',
        3: 'Личный счет',
      },
    }
  },
  computed: {
    hasRooms() {
      return Boolean(this.reservation && this.reservation.suits && this.reservation.suits.length)
    },
    roomsTotal() {
      return roomsTotalFromReservation(this.reservation)
    },
    servicesTotal() {
      return servicesTotalFromReservation(this.reservation)
    },
    tariffTotal() {
      return tariffTotalFromReservation(this.reservation)
    },
    promoDiscount() {
      return promoDiscountAmount(this.reservation, this.tariffTotal)
    },
    promoDiscountLabel() {
      return promoDiscountLabel(this.reservation)
    },
    percentDiscountLines() {
      return buildPercentDiscountLines(this.reservation, this.tariffTotal)
    },
    manualAdjustment() {
      return manualAdjustmentAmount(this.reservation, this.tariffTotal)
    },
    manualAdjustmentLabel() {
      if (!this.reservation) return 'Корректировка суммы'
      return this.reservation.manual_discount_text || 'Корректировка суммы'
    },
    hasAdjustments() {
      return hasPricingAdjustments(this.reservation, this.tariffTotal)
    },
  },
  watch: {
    'invoice_data.cashbox': {
      handler(newValue) {
        // Если наличная касса (2), то способ оплаты - Наличными (2)
        // Если безналичная касса (1), то способ оплаты - Картой (1)
        this.invoice_data.payment_method = newValue
      },
      immediate: true,
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
    )
  },

  // setup() {
  //   const reservation = null
  //   const front_reservation = null

  //   const invoice_modal = false

  //   return {
  //     reservation,
  //     front_reservation,
  //     invoice_modal,
  //   }
  // },
  async mounted() {
    await this.getFrontReservation()
    await this.getReservation()
  },
  methods: {
    roomStayMeta(room) {
      const parts = []
      if (room.options && room.options.package) {
        parts.push(room.options.package)
      }
      if (room.available_room_type && room.available_room_type.length) {
        parts.push(room.available_room_type[0])
      }
      if (room.options && room.options.type) {
        parts.push(room.options.type)
      }
      if (room.options && room.options.gender) {
        parts.push(room.options.gender)
      }
      return parts.join(' · ')
    },
    showOfdReceiptBlock(invoice) {
      if (invoice.cashbox !== 2) return false
      return Boolean(
        invoice.ofd_receipt_status
        || invoice.ofd_receipt_id
        || (invoice.pay && invoice.payment_method === 2),
      )
    },

    hasReceiptProof(invoice) {
      return Boolean(
        invoice.ofd_receipt_url
        || invoice.ofd_fiscal_sign
        || invoice.ofd_fiscal_document_number,
      )
    },

    canRefreshInvoiceReceipt(invoice) {
      if (!invoice.ofd_receipt_id) return false
      if (invoice.ofd_receipt_status === 'wait') return true
      if (invoice.ofd_receipt_status === 'done' && !this.hasReceiptProof(invoice)) return true
      return false
    },

    ofdReceiptStatusLabel(status) {
      const labels = {
        wait: 'Обрабатывается на ККТ',
        done: 'Выбит',
        fail: 'Ошибка ККТ',
        FERMAERROR: 'Ошибка отправки в ОФД',
      }
      return labels[status] || status || 'Не отправлялся'
    },

    ofdReceiptStatusColor(status) {
      const colors = {
        wait: 'warning',
        done: 'success',
        fail: 'error',
        FERMAERROR: 'error',
      }
      return colors[status] || 'default'
    },

    formatReceiptDt(value) {
      if (!value) return ''
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ru-RU')
    },

    async refreshInvoiceReceipt(invoiceId) {
      this.refreshingReceiptId = invoiceId
      try {
        await Api.checkReceipt(invoiceId)
        await this.getReservation()
      } catch { }
      finally {
        this.refreshingReceiptId = null
      }
    },

    async getReservation() {
      try {
        Api.getReservationByUuid({
          reservation_uuid: this.$route.params.reservation_id,
          event_id: this.$route.params.id,
        }).then(
          (event => {
            this.$set(this, 'reservation', event)
          }),
        )
      } catch { }
    },
    async getFrontReservation() {
      try {
        Api.getReservation({
          reservation_uuid: this.$route.params.reservation_id,
        }).then(
          (event => {
            this.$set(this, 'front_reservation', event)
          }),
        )
      } catch { }
    },
    async deleteInvoice(invoice_id) {
      try {
        Api.deleteInvoice({
          invoice_id,
        }).then(
          (event => {
            this.getFrontReservation()
            this.getReservation()
          }),
        )
      } catch { }
    },
    async checkPay(invoice_id) {
      try {
        Api.checkPay({
          invoice_id,
        }).then(
          (event => {
            if (event.Payments) {
              alert(`Статус: ${event.Payments[0].Status} Сумма: ${event.Payments[0].Amount / 100}`)
            } else {
              alert(event.Message)
            }
          }),
        )
      } catch { }
    },
    async updateInvoicePayStatus(invoice_id, pay) {
      try {
        Api.updateInvoicePayStatus({
          invoice_id,
          pay,
        }).then(
          (event => {
            this.getFrontReservation()
            this.getReservation()
          }),
        )
      } catch { }
    },
    startEditTag(invoice) {
      this.editTagInvoiceId = invoice.id
      this.editTagValue = invoice.cash_register_tag || ''
    },
    cancelEditTag() {
      this.editTagInvoiceId = null
      this.editTagValue = ''
    },
    async saveInvoiceTag(invoiceId) {
      try {
        await Api.updateInvoice({
          invoice_id: invoiceId,
          cash_register_tag: this.editTagValue,
        })
        this.cancelEditTag()
        this.getFrontReservation()
        this.getReservation()
      } catch { }
    },
    async clearInvoiceTag(invoiceId) {
      try {
        await Api.updateInvoice({
          invoice_id: invoiceId,
          cash_register_tag: '',
        })
        this.cancelEditTag()
        this.getFrontReservation()
        this.getReservation()
      } catch { }
    },
    async createCashInvoice() {
      try {
        Api.createCashInvoice({
          reservation_uuid: this.front_reservation.reservation_uuid,
          invoice_data: this.invoice_data,
        }).then(
          (event => {
            this.getReservation()
          }),
        )
      } catch { }
    },
    async doCancel() {
      this.cancel_loading = true
      try {
        await Api.cancelReservation({
          reservation_uuid: this.$route.params.reservation_id,
          reason: this.cancel_reason,
        })
        this.cancel_dialog = false
        await this.getReservation()
        await this.getFrontReservation()
      } catch (e) {
        console.error(e)
      } finally {
        this.cancel_loading = false
      }
    },
    confirmDelete(uuid) {
      this.delete_uuid = uuid
      this.delete_reservation_dialog = true
    },
    async deleteResesrvation(uuid) {
      if (this.delete_confirm == 'УДАЛИТЬ') {
        this.delete_error = null
        this.delete_reservation_dialog = false
        try {
          Api.deleteReservation({
            reservation_uuid: uuid,
          }).then(
            (event => {
              this.$router.push({
                path: `/events/${this.$route.params.id}`,
                replace: true,
              })
            }),
          )
        } catch { }
      } else {
        this.delete_error = 'подтвердите удаление'
      }
    },
    async confirmReservation(uuid) {
      Api.confirmReservation({
        reservation_uuid: uuid,
      }).then(
        (event => {
          this.getReservation()
        }),
      )
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/plugins/vuetify/default-preset/preset/mixins.scss';

.avatar-center {
  top: -2rem;
  left: 1rem;
  border: 3px solid white;
  position: absolute;
}

// membership pricing
@include theme--child(memberpricing-bg) using ($material) {
  background-color: rgba(map-deep-get($material, 'primary-shade'), map-deep-get($material, 'states', 'hover'));
}

.memberpricing-bg {
  position: relative;
}

.membership-pricing {
  text-align: center;

  sup {
    font-size: 3.75rem;
    top: 9px;
  }
}

.summary_block {
  background: #f6f7f9;
  border-radius: 10px;
  margin: 10px 10px 10px;
}

.list_payment {
  margin: 2px 0;
}

.list_payment_final {
  margin: 2px 0;
  font-size: 16px;
}

.v-card .v-card__title {
  line-height: inherit;
}

.client_data {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 15px;
}

.list_small_data {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 11px;
}

.aling_right {
  text-align: right;
}

.discount-list {
  margin: 10px 0 15px 0;
  padding: 0;
  list-style: none;

  li {
    align-items: center;
    line-height: 1.5;

    &:not(:last-child):not(:only-child) {
      border-bottom: 1px solid #e7e7e7;
      margin-bottom: 0.5rem;
      padding-bottom: 0.5rem;
    }

    small {
      margin-right: 20px;
    }
  }

  .summary-price {
    font-size: 13px;
    font-weight: bold;
  }
}

.invoice-info {
  font-size: 14px;

  .font-weight-medium {
    color: #666;
  }
}

.pricing-summary {
  text-align: left;

  .pricing-section-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 8px;
  }

  .pricing-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 4px 0;
    line-height: 1.4;
  }

  .pricing-label {
    flex: 1;
    min-width: 0;
    padding-right: 12px;
  }

  .pricing-value {
    font-weight: 500;
    white-space: nowrap;
  }

  .pricing-row--subtotal .pricing-label,
  .pricing-row--subtotal .pricing-value {
    font-weight: 600;
  }

  .pricing-row--discount {
    .pricing-label,
    .pricing-value {
      color: #2e7d32;
      font-size: 13px;
    }
  }

  .pricing-row--total {
    padding-top: 4px;

    .pricing-label {
      font-size: 16px;
      font-weight: 600;
    }

    .pricing-value--total {
      font-size: 20px;
      font-weight: 700;
      color: #1565c0;
    }
  }

  .pricing-meta {
    display: block;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-weight: 400;
    margin-top: 2px;
  }

  .pricing-room-block + .pricing-room-block {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px dashed rgba(0, 0, 0, 0.08);
  }

  .pricing-payment-status {
    font-size: 15px;
    line-height: 1.6;
  }
}
</style>
